module.exports = __webpack_public_path__ + "img/20220116_161306.36b12343.jpg";